import ToastPortal from './ToastPortal';

const portal = new ToastPortal();

export default portal;
